module.exports = __webpack_public_path__ + "img/moneySelected.c68c4043.jpg";